import React from 'react'
import { makeStyles } from '@material-ui/core/styles';
import CTAButton from './CTAButton';

const useStyles = makeStyles({
    getCertified: {
        paddingTop: '80px',
        paddingBottom: '80px',
        textAlign: 'center',
        '@media screen and (max-wdith: 480px)': {
            paddingTop: '40px',
            paddingBottom: '40px',
        }
    },
    
    getCertifiedBody: {
        '& img': {
            width: '800px',
        }
    }
})

function GetCertified() {

    var classes = useStyles()

    return (
        <div className={classes.getCertified}>
            <div className="container">
                <div className={classes.getCertifiedHeader}>
                    <h1>Get Certified</h1>
                    <p>Yes! You will receive a certificate once you complete the Program.</p>
                </div>
                <div className={classes.getCertifiedBody}>
                    <img src="/pitchbattle/images/Morgan Maxwell.jpg" alt="Completion Certificate"/>
                </div>
                <CTAButton />
            </div>
        </div>
    )
}

export default GetCertified
